import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AirportService } from '../airport.service';
import { EditWebcamComponent } from '../edit-webcam/edit-webcam.component';
import { DeleteWebcamComponent } from '../delete-webcam/delete-webcam.component';
var AirportWebcamsComponent = /** @class */ (function () {
    function AirportWebcamsComponent(_toggleService, _snackBar, _editWebcamDialog, _deleteWebcamDialog, _airportService) {
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editWebcamDialog = _editWebcamDialog;
        this._deleteWebcamDialog = _deleteWebcamDialog;
        this._airportService = _airportService;
    }
    AirportWebcamsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.editModeSet = this._toggleService.getState();
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    AirportWebcamsComponent.prototype.webcamUrl = function (url) {
        var website = url || '';
        if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
            return url;
        }
        else {
            return 'http://' + url;
        }
    };
    AirportWebcamsComponent.prototype.hasFboWebcams = function () {
        var retVal = false;
        this.airport.businesses.forEach(function (business) {
            if (business.webcams.length > 0) {
                retVal = true;
            }
        });
        return retVal;
    };
    AirportWebcamsComponent.prototype.getFboWebcams = function (business) {
        var fboWebcams;
        fboWebcams = [];
        if (business.webcams.length > 0) {
            business.webcams.forEach(function (businessWebcam) {
                fboWebcams.push(businessWebcam);
            });
        }
        return fboWebcams;
    };
    AirportWebcamsComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AirportWebcamsComponent.prototype.openEditWebcamDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airID: this.airport.airportId,
            webcam: null,
            isNew: false,
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.webcam = this.airport.webcams[index];
        dialogConfig.data['airID'] = this.airport.airportId;
        dialogConfig.width = '60%';
        var dialogRef = this._editWebcamDialog.open(EditWebcamComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            _this.reloadAirport(_this.airport.identifier);
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    // this.airport.pilotControlledLighting.push(isUpdated.pcl);
                    // this.reloadAirport(this.airport.identifier);
                    _this._snackBar.open('Webcam', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Webcam', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    AirportWebcamsComponent.prototype.deleteWebcam = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airportID: this.airport.airportId,
            webcamId: this.airport.webcams[index].webcamId
        };
        var dialogRef = this._deleteWebcamDialog.open(DeleteWebcamComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Webcam', 'Deleted', {
                    duration: 2000
                });
                // this.airport.localAttractions.splice(index, 1);
                _this.reloadAirport(_this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return AirportWebcamsComponent;
}());
export { AirportWebcamsComponent };
